/* BOE Master JS File */

$(document).ready(function () {
    $('a[data-toggle="tab"]').on('show.bs.tab', function (e) {
        $(this).parent().addClass('active');
    });
    $('a[data-toggle="tab"]').on('hide.bs.tab', function (e) {
        $(this).parent().removeClass('active');
    });
});

$(document).ready(function (e) {
    if(!window.app.cookies.get('modalShown')) {
        $('.modal--alert').modal('show');
        window.app.cookies.set('modalShown', true, 1000 * 60 * 60);
    }
})